import {StructuredDataContent} from 'rlink-repos/content';
export class TwitchConfig extends StructuredDataContent {
  static get contentIcon () {
    return 'twitch';
  }

  static get isAdministrative () {
    return true;
  }
  static get path () {
    return '/content/twitch-config.json'
  }

  static defaultData () {
    return {
      streams: "",
    }
  }

  get clientId () {
    return this.data.get('clientId');
  }

  get whitelistGroups () {
    return this.data.get('whitelistGroups');
  }

  get adminLabel () {
    return 'Twitch Config';
  }

  get linkedContentPaths () {
    let contentPaths = [];
    for (let group of this.whitelistGroups) {
      for (let channel of group.get('whitelistChannels')) {
        let thumbnail = channel.get('thumbnail');
        if (thumbnail) {
          contentPaths.push(thumbnail);
        }
      }
    }

    return contentPaths;
  }

  static get (repo) {
    return this.fetchOrMakeFromPath(repo, this.path, {
      whitelistGroups: []
    });
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-twitch/index.js